import {
  GetProposalQuery,
  SetProposalLineItemQuantityInput,
} from '@/gql/graphql';

import {
  isProposalLineItemId,
  produceProposalGroupChildren,
} from './proposalSectionTree';

/**
 * Updates the targeted line item wherever it is nested. Totals are left untouched
 * — the proposal invalidation on success reconciles them.
 */
export const applyProposalLineItemQuantity = (
  data: GetProposalQuery,
  input: SetProposalLineItemQuantityInput
): GetProposalQuery =>
  produceProposalGroupChildren(data, (children) => {
    for (const child of children) {
      if (
        child.__typename === 'ProposalGroupLineItem' &&
        isProposalLineItemId(child.proposalLineItem, input.proposalLineItemId)
      ) {
        child.proposalLineItem.quantity = input.quantity;
      }
    }
  });
